import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { find } from 'lodash'

import { areSameValue } from '../../core/utils'

import { apolloService } from '../../common/services'

import { MENU_CURATION_TASK_REFRESH_COUNTS_QUERY } from '../../menu-curation-tasks/graphql/queries'
import { REFRESH_MENU_CURATION_TASK_COUNTS } from '../../menu-curation-tasks/redux/action-types'
import { UNCONFIRM_UNKNOWN_WORD_MUTATION } from '../graphql/mutations'
import { UNCONFIRM_UNKNOWN_WORD } from '../redux/action-types'

const useUnconfirmUnknownWordMutation = unknownWordId => {
  const { id: menuCurationTaskId } = useParams()
  const dispatch = useDispatch()

  const { isLoading, error } =
    useSelector(store =>
      find(store.unknownWords.unknownWords?.data?.result, ({ id }) =>
        areSameValue(id, unknownWordId),
      ),
    ) || {}

  const onSuccess = useCallback(
    () =>
      apolloService.query({
        query: MENU_CURATION_TASK_REFRESH_COUNTS_QUERY,
        variables: { id: menuCurationTaskId },
        dispatch,
        action: REFRESH_MENU_CURATION_TASK_COUNTS,
      }),
    [dispatch, menuCurationTaskId],
  )

  const mutate = useCallback(
    () =>
      apolloService.mutate({
        mutation: UNCONFIRM_UNKNOWN_WORD_MUTATION,
        variables: { id: unknownWordId },
        dispatch,
        action: UNCONFIRM_UNKNOWN_WORD,
        onSuccess,
      }),
    [dispatch, onSuccess, unknownWordId],
  )

  return [mutate, { isLoading, error }]
}

export default useUnconfirmUnknownWordMutation
